import {toast} from 'react-toastify';

const INITIAL_STATE = {
  todos: [],
  novo: null,
  carregando: false,
  erro: null,
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type){
    case 'REQUISITAR_USUARIO_CONTRATO':
      return {...state, carregando: true};
    case 'ERRO_CONTRATO':
      return {...state, carregando: false, erro: action.erro};
    case 'NOVO_USUARIO_CONTRATO':
      return {...state, carregando: false, novo: action.usuarioContrato, erro: null};
    case 'OBTER_TODOS_USUARIOS_PELO_CONTRATO':
      return {...state, carregando: false, todos: action.usuarioContrato, erro: null};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/UsuarioContratoReducer.js